import useWorkflowSteps from '~/containers/viewer/explorer-sidebar/WorkflowStepper/useWorkflowSteps';

export function useRoiPreviewVisibility(): boolean {
    const { workingStep } = useWorkflowSteps();
    return workingStep?.id === 'contouring' || workingStep?.id === 'review';
}
